import React from "react";

const FaviconSVG = ({ className = "" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      viewBox="0 0 1000 1000"
      space="preserve"
      className={className}
    >
      <g>
        <g>
          <g>
            <path d="M541.6,73.7c0,0,104.2,73.3,239.4,13c0,0,1.6,86.3,84.7,154.7c0,0-68.4,48-23.6,183.2     c44.8,135.2,116.5,314.4-297.3,539.2C259.2,807.2,204,672.6,211.8,559.7l45,67c1.6,7,3.5,14.1,5.8,21.3     c38.2,116.1,177,209.9,282.3,269.4C650,858.6,790.1,764.8,826.7,648.5c23.5-74.8,0.3-140.2-23.1-211     c-17.9-54.1-25.9-115.6-4.4-169.9c2.9-7.4,6.7-15.2,11.2-22.7c-24.6-26.7-43.9-57.8-56.3-92.4c-1.3-3.7-2.6-7.6-3.9-11.7     c-48.5,13.1-99.1,14.2-149.1,1.7c-18.5-4.6-40.2-12.2-59.4-21.7c-19,9.5-40.4,17.1-58.8,21.7c-49.5,12.5-99.5,11.5-147.5-1.5     c-1.2,4-2.5,7.8-3.8,11.4c-12.3,34.6-31.4,65.7-55.9,92.5c4.5,7.6,8.3,15.5,11.2,22.9c16.1,41,15.5,86.1,6.5,129l-38.1-17.1     c17.6-101-34.8-138.2-34.8-138.2c82.3-68.4,83.9-154.7,83.9-154.7C438.4,147,541.6,73.7,541.6,73.7z" />
            <path d="M177.9,428.1c-8.6,0-15.6,7.3-15.6,16.4s7,16.4,15.6,16.4s15.6-7.3,15.6-16.4S186.6,428.1,177.9,428.1z" />
            <path d="M442.8,166.2c0,0,18.6,157.4-127,234.6c0,0-77.2-62.5-137.8-43c-60.6,19.5-82.1,74.3-93.8,125.1l-36.2,43     l51.8-21.5c0,0,35.7-19.5,98,48.9c0,0,113.1,267.8,334,213c0,0,33.7,78.7,70.4,64c36.6-14.7,34.7-75.7,26.4-86.5     c-8.3-10.8-38.1-6.3-38.1-6.3l-45,5.4c0,0-44-95.3-52.8-117.8c-8.8-22.5-28.3-53.8-28.3-53.8S662.2,456,519.5,207.8l-20,94.8     C499.5,302.6,478,213.6,442.8,166.2L442.8,166.2z M281.5,425.7c0,0-55.7,47.4-63,114.3c0,0-36.7-66.5-92.8-63     c0,0,2.5-85.5,79.7-85C205.3,392,255.1,394.9,281.5,425.7L281.5,425.7z M458.9,276.2c66.9,185.7-39.6,250.7-69.4,309.3     s-20,114.8-20,114.8c-70.4-40.1-107.5-128-107.5-128c-2-63.5,59.1-136.3,119.7-174.5C442.3,359.7,458.9,276.2,458.9,276.2     L458.9,276.2z M436.9,559.1c91.2-101.2,70.4-209.6,70.4-209.6l18.6-36.6c0,0,26.9,44,11.7,116.8     C522.4,502.4,436.9,559.1,436.9,559.1L436.9,559.1z M447.2,600.2L510.7,738c0,0-67.8,11.5-114.4-19.5     C396.4,718.4,393.4,629.5,447.2,600.2L447.2,600.2z M564.9,770.2c40.1-10.3,40.1-1,40.1-1c4.4,20.5-10.8,29.3-10.8,29.3     C578.1,801.5,564.9,770.2,564.9,770.2z" />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default FaviconSVG;
